module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "Bullet_Hole-4.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Bullet_Hole2#Contents-A"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("‘The only way,’ I said to Alexander, ‘of really finding out a man’s true character is to play golf with him. In no other walk of life does the cloven hoof so quickly display itself.’")]), _vm._v(" "), _c('p', {
    staticClass: "quote-by"
  }, [_vm._v("P.G. Wodehouse: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ordeal By Golf")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a837f3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Bullet_Hole-4.vue
// module id = 72
// module chunks = 0